import QuestionMark from '@assets/vectors/question-mark-small.inline.svg';

import QuickLink from '.';

const HelpCenter: QuickLink = ({ header, description }) => {
	return {
		Icon: QuestionMark,
		header,
		description,
		pathName: process.env.GATSBY_SUPPORT_LINK!,
	};
};

export default HelpCenter;
